import { MantineProvider } from '@mantine/core';
import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { createQueryClient } from '../shared/api/queryClient';
import { theme } from './theme';

/**
 * Провайдеры приложения. Клиент запросов создаётся один раз на жизнь дерева: `useState`
 * с инициализатором, а не модульная константа, чтобы каждый тест и каждый экземпляр
 * `<App />` получали свой кэш.
 */
export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <MantineProvider theme={theme}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </MantineProvider>
  );
}
